export default __webpack_public_path__ + "static/media/pyposition_63a.205d8d15.png";